__turbopack_context__.v({
  "root": "fieldset-module__FPpKmq__root",
});
